<script setup>
import { onMounted, ref } from "vue";
import { useForm } from '@inertiajs/vue3';
import { Modal } from "bootstrap";
import { QuillEditor } from '@vueup/vue-quill';
import Multiselect from '@vueform/multiselect';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';

const props = defineProps({
    roomamenities: Array,
    allRoomCategory: Array,
    flash: Object,
    addcard: Boolean,
    rooms: Object,
    hotelsById: Object,
});

let modalEle = ref(null);
let thisModalObj = null;
let isLoading = ref(false);
const $toast = useToast();

onMounted(() => {
    thisModalObj = new Modal(modalEle.value);
    if (props.addcard == true) {
        thisModalObj.show()
    } else {
        thisModalObj.hide()
    }
});

const options = props.roomamenities;

const RoomAddform = useForm({
    description: '',
    baby_cot_availability: '',
    number_of_rooms: '',
    extra_bed_allowed: '',
    room_category_id: null,
    amenity_id: [],
    room_image: null,
    hotel_id: props.hotelsById.id,
});

const RoomAddformSubmit = () => {
    RoomAddform.post('/rooms/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/css/vue-quill.snow.css";
@import "@vueform/multiselect/themes/default.css";
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <div class="vld-parent">
        <Loading v-model:active="isLoading" :color="'#696cff'" />
    </div>
    <div class="modal-onboarding modal fade animate__animated" id="onboardHorizontalImageModal" tabindex="-1"
        ref="modalEle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <form class="pl-3 pr-3" @submit.prevent="RoomAddformSubmit">
                <div class="modal-content">
                    <div class="modal-body onboarding-horizontal p-0">
                        <div class="onboarding-content mb-0">
                            <h4 class="onboarding-title text-body mb-4">Add Room Details</h4>

                            <div class="row g-3">
                                <div class="col-md-12">
                                    <label for="room_category_id">Room Category</label>
                                    <select class="form-select" name="room_category_id"
                                        v-model="RoomAddform.room_category_id"
                                        :class="{ 'is-invalid': RoomAddform.errors.room_category_id }">
                                        <option disabled="disabled" selected="selected">Select room category...</option>
                                        <option v-for="roomCategory in props.allRoomCategory" :value="roomCategory.id">
                                            {{ roomCategory.name }}
                                        </option>
                                    </select>
                                    <div v-if="RoomAddform.errors.room_category_id" class="invalid-feedback">
                                        <div v-text="RoomAddform.errors.room_category_id">
                                        </div>
                                    </div>
                                </div>

                                <div class="row g-3">
                                    <div class="col-md-3">
                                        <label for="baby_cot_availability" class="col-form-label"><b>Baby Cot
                                                Available</b></label>
                                        <select class="form-select" name="baby_cot_availability"
                                            v-model="RoomAddform.baby_cot_availability"
                                            :class="{ 'is-invalid': RoomAddform.errors.baby_cot_availability }">
                                            <option disabled="disabled" selected="selected">Select option ...</option>
                                            <option value="0"> No </option>
                                            <option value="1"> Yes </option>
                                        </select>
                                        <div v-if="RoomAddform.errors.baby_cot_availability" class="invalid-feedback">
                                            <div v-text="RoomAddform.errors.baby_cot_availability">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="extra_bed_allowed" class="col-form-label"><b>Extra Bed
                                                Allowed</b></label>
                                        <select class="form-select" name="extra_bed_allowed"
                                            v-model="RoomAddform.extra_bed_allowed"
                                            :class="{ 'is-invalid': RoomAddform.errors.extra_bed_allowed }">
                                            <option disabled="disabled" selected="selected">Select option ...</option>
                                            <option value="0"> No </option>
                                            <option value="1"> Yes </option>
                                        </select>
                                        <div v-if="RoomAddform.errors.extra_bed_allowed" class="invalid-feedback">
                                            <div v-text="RoomAddform.errors.extra_bed_allowed">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="number_of_rooms" class="col-form-label"><b>No.of Units</b></label>
                                        <input type="number" class="form-control" name="number_of_rooms"
                                            placeholder="Number of units of this type"
                                            :class="{ 'is-invalid': RoomAddform.errors.number_of_rooms }"
                                            v-model="RoomAddform.number_of_rooms">
                                        <div v-if="RoomAddform.errors.number_of_rooms" class="invalid-feedback">
                                            <div v-text="RoomAddform.errors.number_of_rooms">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <label for="room_image" class="col-form-label"><b>Room Image </b></label>
                                        <input type="file" name="room_image" class="form-control"
                                            @input="RoomAddform.room_image = $event.target.files[0]"
                                            :class="{ 'is-invalid': RoomAddform.errors.room_image }">
                                        <progress v-if="RoomAddform.progress" :value="RoomAddform.progress.percentage"
                                            max="100">
                                            {{ RoomAddform.progress.percentage }}%
                                        </progress>
                                        <div v-if="RoomAddform.errors.room_image" class="invalid-feedback">
                                            <div v-text="RoomAddform.errors.room_image">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row g-3 mb-3">
                                    <label for="room_category_id"><b>Room Amenities</b></label>
                                    <Multiselect v-model="RoomAddform.amenity_id" :options="options" mode="tags"
                                        :closeOnSelect="false" :searchable=true placeholder="Select room amenities ..."
                                        track-by="name" label="name" :object="true" :required=true />
                                </div>
                                <div class="row g-1">
                                    <label for="description"><b>Description</b></label>
                                    <QuillEditor theme="snow" placeholder="   Enter room description"
                                        v-model:content="RoomAddform.description" contentType="html" toolbar="essential"
                                        object="true" :searchable="true" name="description"
                                        :class="{ 'is-invalid': RoomAddform.errors.description }" />
                                    <div v-if="RoomAddform.errors.description" class="invalid-feedback">
                                        <div v-text="RoomAddform.errors.description">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer border-0 mt-3">
                        <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal">
                            Close
                        </button>
                        <button type="submit" class="btn btn-primary" :disabled="RoomAddform.processing">Add</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>